import React from "react";
import InnerPageDefaultLayout from "../../helpers/InnerPageDefaultLayout";
import MainSection from "./MainSection";
// import background from "../../../assets/images/banner/about_us.jpg";

export default function AboutSeven() {
  return (
    <InnerPageDefaultLayout
      background="https://nct-social-media-icon.s3.ap-south-1.amazonaws.com/images/banner/about_us.jpg"
      pageTitle="About Us"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "About Us", path: "/about" },
      ]}
    >
      <MainSection />
    </InnerPageDefaultLayout>
  );
}
